import Page from "webPage/Page";
import CanvasImage from "../CanvasImage";

Page.register(['/news-and-events', '/projects'], function () {

    $(".project__image").each((i, el) => {
        new CanvasImage($(el), i % 2 === 0 ? PROJECTS_MASKS_1 : PROJECTS_MASKS_2);
    });
});

window.PROJECTS_MASKS_1 = {
    0: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask--mobile.png',
            'vPos': 'bottom',
            'hPos': 'center'
        }
    ],
    600: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask--laptop.png',
            'vPos': 'bottom'
        }
    ],
    1200: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask.png',
            'vPos': 'bottom'
        }
    ]
};
window.PROJECTS_MASKS_2 = {
    0: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask--mobile.png',
            'vPos': 'bottom',
            'hPos': 'center'
        }
    ],
    600: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask-2--laptop.png',
            'vPos': 'bottom'
        }
    ],
    1200: [
        {
            'url': '/images/png/masks/projects/project-thumbnail-mask-2.png',
            'vPos': 'bottom'
        }
    ]
};
